import { render, staticRenderFns } from "./socialManage.vue?vue&type=template&id=617d120c&"
import script from "./socialManage.vue?vue&type=script&lang=js&"
export * from "./socialManage.vue?vue&type=script&lang=js&"
import style0 from "./socialManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports